import Axios from 'src/utils/axiosConfig';
import {
  SET_ORDERS,
  LOADING_ORDERS,
  SET_SELECTED_ORDER,
  SET_ORDER_ERROR,
  SET_ORDER_REPORT_STATUS,
} from './order.type';

const getLatestOrders = () => async (dispatch) => {
  dispatch({ type: LOADING_ORDERS, value: true });

  try {
    const result = await Axios.post('admin/orders/all?page=1&pageSize=5', {});
    dispatch({ type: LOADING_ORDERS, value: false });
    dispatch({ type: SET_ORDERS, orders: result.data.data });
  } catch (error) {
    dispatch({ type: LOADING_ORDERS, value: false });
    dispatch({ type: SET_ORDER_ERROR, error: error.message });
  }
};

const filterOrders = (payload, pagination) => async (dispatch) => {
  const body = { ...payload, includeDistributorNames: true };
  dispatch({ type: LOADING_ORDERS, value: true });

  try {
    const result = await Axios.post(`admin/orders/all?page=${pagination.page}&pageSize=${pagination.pageSize}`, body);
    dispatch({ type: LOADING_ORDERS, value: false });
    dispatch({ type: SET_ORDERS, orders: result.data.data });
  } catch (error) {
    dispatch({ type: LOADING_ORDERS, value: false });
    dispatch({ type: SET_ORDER_ERROR, error: error.message });
  }
};

const filterOrderCsv = async (payload) => {
  const body = { ...payload, includeDistributorNames: true };

  const result = await Axios.post('admin/orders/filter/csv', body);
  return result.data;
};

const getOrderDetails = (orderId) => async (dispatch) => {
  dispatch({ type: LOADING_ORDERS, value: true });

  try {
    const result = await Axios.get(`orders/${orderId}?isAdmin=1&filterDistributors=1`);
    dispatch({ type: LOADING_ORDERS, value: false });
    dispatch({ type: SET_SELECTED_ORDER, order: result.data.data });
  } catch (error) {
    dispatch({ type: LOADING_ORDERS, value: false });
    dispatch({ type: SET_ORDER_ERROR, error: error.message });
  }
};

const getOrderReportStatus = () => async (dispatch) => {
  dispatch({ type: LOADING_ORDERS, value: true });

  try {
    const result = await Axios.get('orders/report/count/status');
    dispatch({ type: LOADING_ORDERS, value: false });
    dispatch({ type: SET_ORDER_REPORT_STATUS, status: result.data.data });
  } catch (error) {
    dispatch({ type: LOADING_ORDERS, value: false });
    dispatch({ type: SET_ORDER_ERROR, error: error.message });
  }
};

export {
  filterOrders,
  getOrderDetails,
  getLatestOrders,
  getOrderReportStatus,
  filterOrderCsv,
};
